import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { baseUrl, Fetch } from "../../../shared/Fetch";
import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";

export interface IEmployerDetail {

}

interface Iprops {
    data: Array<any>
    open: boolean,
    hideDialog: () => void,
    toast: any,
    consultant_ID: number | undefined,
    onEmployerSelect: (employer: any) => void;

}

export const EmployerDetails = (props: Iprops) => {

    const [selectedEmployer, setSelectedEmployer] = useState<any>(null);
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<any>, loading: boolean });

    const onHide = () => {
        props.hideDialog();
    }


    const getEmployerDetails = async () => {
        const response = await Fetch("Consultant_Mast/getEmployerInfo", "GET", null, `consultant_ID=${props.consultant_ID}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };


    const footerTemplate = () => {
        return <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <>
                <Button className="p-button-sm my-1" label="Fill Employer Details" type="button" onClick={handleSubmit} />
                <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" type="button" onClick={onHide} />
            </>
        </div>
    }

    // Function to handle selection of radio button
    const radioBodyTemplate = (rowData: any) => {
        return (
            <RadioButton
                inputId={rowData.contact_Person_Name}
                name="selectedEmployer"
                value={rowData}
                onChange={(e) => setSelectedEmployer(e.value)}
                checked={selectedEmployer?.vendor_Company_ID === rowData.vendor_Company_ID}
            />
        );
    }

    const handleSubmit = () => {
        if (selectedEmployer) {
            props.onEmployerSelect(selectedEmployer);
            onHide();
        }
    }

    useEffect(() => {
        if (props.consultant_ID) {
            getEmployerDetails();
        }
    }, [props.consultant_ID]);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Employers Details" footer={footerTemplate} className="p-fluid" onHide={onHide} modal>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small"
                value={tableData.tableData}
                emptyMessage="No Data found."
                loading={tableData.loading}
            >
                <Column header="" body={radioBodyTemplate} />
                <Column field="company" header="Sub Vendor Company" />
                <Column field="contact_Person_Name" header="Contact Person Name" />
                <Column field="contact_Person_EmailID" header="Contact Person EmailID" />
                <Column field="phone_No" header="Phone No." />

            </DataTable>
        </Dialog>
    );
}